export class EnumObj {
    readonly id: string;
    readonly value: string;
    readonly cod: number = 0;

    constructor(id: string, value: string);
    constructor(id: string, value: string, cod: number);
    constructor(id: string, value: string, cod?: number) {
        this.id = id;
        this.value = value;
        this.cod = cod || 0;
    }
}
